<template>
    <svg
        viewBox="0 0 18 15"
        class="h-full w-full fill-current"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.2807 0.463941C18.1291 1.17133 18.2433 2.4325 17.536 3.28083L8.36354 14.2808C7.96775 14.7555 7.37477 15.0205 6.75714 14.9988C6.13951 14.977 5.56663 14.671 5.20519 14.1697L0.377607 7.47402C-0.26839 6.57805 -0.0657469 5.32804 0.830223 4.68204C1.72619 4.03604 2.9762 4.23869 3.6222 5.13466L6.94225 9.73942L14.4639 0.719146C15.1712 -0.129189 16.4324 -0.243449 17.2807 0.463941Z"
        />
    </svg>
</template>

<script>
/**
 * icon-打勾
 */
export default {
    name: 'IconCheck'
};
</script>
